import Vue from 'vue'
import finColors from '@/js/finColors'
import finBasics from 'fincraft-lib-basics'
import finBreakpoint from "@/js/errorhandler/finBreakpoint"
import 'fincraft-fonts/fonts/fin-icons/style.css'
import 'fincraft-fonts/fonts/gilroy/style.css'
import 'fincraft-fonts/fonts/tiempos/style.css'
import 'fincraft-lib-basics/dist/fincraft-lib-basics.css'

Vue.use(finBasics, {
  blogUrl: '/blog/',
  img: {
    loading: require('@/assets/loading.png'),
    noMarketingCookie: require('@/assets/NoMarketingCookie.png')
  }
})

// locale temporary fixed. TODO: dynamic once the site is multilangual
const locale = 'de-DE'

const number = (value, format, options) => Vue.options.filters.number(value, format, options)
const addSign = (number) => number > 0 ? '+' : ''
const sign = (number) => number < 0 ? '-' : addSign(number)

const currency = (value, symbol, decimalDigits, options) => Vue.options.filters.currency(value, symbol, decimalDigits, options)
const ending = ['Mio', 'Mrd', 'Bio']

const dateOption = {
  year: 'numeric',
  month: 'short',
  day: '2-digit'
}
const timeOption = {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23'
}

// Padding/Margin used to display the pages' contents with the same paddings/margins
Vue.prototype.$finPadding = {
  left: {xs: '12px', sm: '24px', md: '48px', lg: '48px', xl: '48px'},
  right: {xs: '12px', sm: '24px', md: '48px', lg: '48px', xl: '48px'}
}
Vue.prototype.$finMargin = {
  left: {xs: '12px', sm: '24px', md: '48px', lg: '48px', xl: '48px'},
  right: {xs: '12px', sm: '24px', md: '48px', lg: '48px', xl: '48px'}
}
// Vue.prototype.$maxWidth = {xs: '25px', sm: '48px', md: '48px', lg: '48px', xl: '48px'}

// used at SideNaviation + Footer
Vue.prototype.$finSideNav = {
  width: {xs: '0px', sm: '80px', md: '80px', lg: '80px', xl: '80px'},
}


// Padding and maxWidth used to display the landingpages' contents with the same paddings and maxWidths
Vue.prototype.$finLandingMaxWidth = {xs: '100%', sm: '80%', md: '100%', lg: '1000px', xl: '1400px'}

Vue.prototype.$finLandingPadding = {
  left: {xs: '20px', sm: '20px', md: '62px', lg: '0px', xl: '162px'},
  right: {xs: '20px', sm: '20px', md: '62px', lg: '0px', xl: '162px'},
  top: {xs: '48px', sm: '100px', md: '100px', lg: '100px', xl: '110px'}
}

/* *************************************************************************************
 date formats
       The date formats displayed in the application are described below.

       As soon as a date is older than 3 days, the date will be displayed in
       the date format. Otherwise dates are displayed in the timeago format. The limit of
       three days is set in the fin-time-ago component.

       The datetime format is only used for Kursdaten. Kursdaten muessen immer immer im
       Format datetime (Datum + Uhrzeit) angezeigt werden. Das ist eine regulatorische Vorgabe.

       - date        ex: 19. Apr 2020
       - datetime    ex: 19. Apr 2020 - 17:56 Uhr    - only used for Kursdaten
       - timeago     ex: vor x Tagen, vor x Stunden, vor x Minuten, gerade eben => use component fin-time-ago

       TODO: here the only relevant date format functions are date and datetime. The others should be removed if not necessary.
************************************************************************************* */
/** 16. Juli 2020 */
Vue.filter('date', function (date) {
  if (!date) return ''
  if (!(date instanceof Date)) {
    date = new Date(date)
  }

  // use Intl.DateTimeFormat to improve performance when displaying lots of dates
  return new Intl.DateTimeFormat(locale, dateOption).format(date).split(' ').join('\u00A0')
})

/** 16. Juli 2020 - 16:43 Uhr */
Vue.filter('datetime', function (date) {
  if (!date) return ''
  if (!(date instanceof Date)) {
    date = new Date(date)
  }

  const calDate = new Intl.DateTimeFormat(locale, dateOption).format(date).split(' ').join('\u00A0')
  const time = new Intl.DateTimeFormat(locale, timeOption).format(date)

  return calDate + '\u00A0-\u00A0' + time + '\u00A0Uhr'
})

/** used in charts */
Vue.filter('dayShort', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleDateString(locale, {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  })
})

/** 16.03.2020 */
Vue.filter('numericDate', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleDateString(locale, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  })
})

/** 16. Sept. 2020 */
Vue.filter('dayShortYearLong', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleDateString(locale, {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  })
})

/** used in charts: 16. Juli, 15:03 */
Vue.filter('dayAndHourShort', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }

  return value.toLocaleDateString(locale, {
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  })
})

/** used in portfolio slider 16. Juli 2020, 15:03 */
Vue.filter('dayAndHourAndYearShort', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  })
})

/** used in finSpeaker 16. Sept. 2020, 15:03 Uhr */
Vue.filter('dayAndMonthAndYearNumericAndHour', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }) + '\u00A0Uhr'
})

/** used in charts 12:56 */
Vue.filter('hourShort', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  })
})

/** used in charts - Donnerstag, 16. Juli */
Vue.filter('weekdayAndDayMonth', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  return value.toLocaleDateString(locale, {
    month: 'long',
    day: '2-digit',
    weekday: 'long'
  })
})

/** return calendarWeek - KW12 */
Vue.filter('calendarWeek', function (value) {
  if (!value) return ''
  if (!(value instanceof Date)) {
    value = new Date(value)
  }
  const firstDayOfYear = new Date(value.getFullYear(), 0, 1)
  const pastDaysOfYear = (value - firstDayOfYear) / 86400000
  return 'KW ' + Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
})

// number formats

Vue.filter('numberFormatted', function (value) {
  if (value >= 10000) {
    return number(value, '0,0')
  } else if (value >= 1000) {
    return number(value, '0,0.0')
  } else {
    return number(value, '0.00')
  }
})

Vue.filter('numberFormattedShort', function (value) {
  const temp = Vue.filter('numberFormatted')(value)
  let result
  if (value <= (999999)) {
    result = number(value, '0,0.00') // 0 - Tausender 0 - 999.999 (10^3)
  } else if (value <= 999999999) {
    result = number(temp, '00.00') + ' ' + ending[0] // Millionen 1.000.000 - 999.999.999 (10^6)
  } else if (value <= 999999999999) {
    result = number(temp, '00.00') + ' ' + ending[1] // Milliarden 1.000.000.000 - 999.999.999.999 (10^9)
  } else if (value <= 999999999999999) {
    result = number(temp, '00.00') + ' ' + ending[2] // Billionen 1.000.000.000.000 - 999.999.999.999.999 (10^12)
  } else {
    result = number(temp, '00.00') // ERROR
  }
  return replaceNaN(result)
})

Vue.filter('percentage', function (value, change) {
  console.log("percentage", value, change)
  if (change) {
    return sign(change) + currency(Math.abs(100 / (value) * change), '%')
  } else {
    return sign(value) + currency(Math.abs(value * 100), '%')
  }
})

//TODO rework that
Vue.filter('percent', function (value, noSign) {
  if (value !== undefined) {
    try {
      // Round to 2 decimal places
      value = Math.round(value * 100) / 100
      if (isNaN(value)) throw 'NaN'

      // currency returns NaN for values below 0.01, therefore workaround here
      if (value > 0 && value < 0.01) {
        return (noSign ? '' : sign(value)) + currency(0, '%')
      }
      if (value < 0 && value > 0.01) {
        return (noSign ? '' : sign(value)) + currency(0, '%')
      }

      return (noSign ? '' : sign(value)) + currency(Math.abs(value), '%')
    } catch (e) {
      return replaceNaN('')
    }
  } else {
    return ''
  }
})

Vue.filter('numberChange', function (value) {
  return addSign(value) + number(value, '0.00')
})


Vue.filter('currencyChange', function (value, currencySymbol = '€', decimals = 2) {
  return addSign(value) + currencyRounded(fixedDecimals(value), currencySymbol, decimals)
})

/**
 *
 * @param value The number value to be formatted
 * @param currencySymbol the currency prefix/symbol, that will be attached to the rounded number, Default is €
 * @param decimals Number of decimals to round to, Default is 0
 * @return Returns the formatted number and tests if it is null/undefined, if that's the case it returns -
 */
let currencyRounded = function (value, currencySymbol = '€', decimals = 0) {
  return replaceNaN(currency(value, currencySymbol, decimals))
}
Vue.filter('currencyRounded', currencyRounded)

const replaceNaN = function (value) {
  if (value instanceof String) {
    value = value.trim()
  }
  let result
  if (value === 'NaN' || value === '') {
    result = '-'
  } else {
    result = value
  }
  return result
}
Vue.filter('isNaN', replaceNaN)

/**
 * A filter to transform a given number to a fixed number of decimals. Can handle numbers with a lot of decimals
 * (e.g. 9.094947017729282e-13 => 0,00).
 * @param value - the number to format
 * @param nrOfDecimals - nr of decimals to display
 * @return {number} - the formatted number with the fixed decimals
 */
const fixedDecimals = function (value, nrOfDecimals = 2) {
  const factor = Math.pow(10, nrOfDecimals)
  return Math.round((value + Number.EPSILON) * factor) / factor
}
Vue.filter('fixedDecimals', fixedDecimals)

/**
 * Custom filter which can handle numbers with lots of decimals (e.g. 9.094947017729282e-13 => 0,00 €) which internally
 * calls the Vue2Filters.currency filter after restricting the decimals.
 */
Vue.filter('finCurrency', (value) => {
  return currency(fixedDecimals(value))
})

// colors and fonts

// TODO color schema background, accentGray1... can we define the colors at just one place? At the moment we need to define them thrice!
Vue.prototype.$finColors = finColors

// strategy colors
Vue.prototype.$finStrategyColors = [
  // SHARE strategy colors
  {type: 'INCOME', color: Vue.prototype.$finColors.accentYellow},
  {type: 'QUALITY', color: Vue.prototype.$finColors.accentBlue},
  {type: 'TREND_FOLLOWING', color: Vue.prototype.$finColors.paleRed},
  {type: 'GROWTH', color: Vue.prototype.$finColors.accentGreen},
  {type: 'VALUE', color: Vue.prototype.$finColors.darkGreen},
  // ETF strategy colors
  {type: 'BASIC', color: Vue.prototype.$finColors.accentYellow},
  {type: 'CONSERVATIVE', color: Vue.prototype.$finColors.accentGreen},
  {type: 'DYNAMIC', color: Vue.prototype.$finColors.paleRed},
]


// TODO: We usually use the body/heading font variables defined in variables.scss. $finFonts is used once to define the fonts in highcharts.
//  Is it possible to define the fonts just once and make the one definition available everywhere?
Vue.prototype.$finFonts = {
  /**
   * @type "Gilroy"
   */
  body: 'Gilroy',
  /**
   * @type "Tiempos"
   */
  header: 'Tiempos'
}

// dialogs

export const EventBus = new Vue()

export const currencyFilter = currency

Vue.prototype.$alert = function (options) {
  EventBus.$emit('alert', {options})
}

Vue.prototype.$confirm = function (options) {
  return new Promise((resolve, reject) => {
    EventBus.$emit('confirm', {resolve, reject, options})
  })
}

// browser
// we do not support IE any more. We support Chrome, Firefox and Edge

Vue.prototype.$browser = function () {
  const ua = window.navigator.userAgent

  // IE 10 or older
  const msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    return 'ie'
  }

  // IE 11
  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    return 'ie'
  }

  // Edge (IE 12+)
  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    return 'edge'
  }

  // other browser
  return ''
}

// breakpoints
//const sizes = ['xl', 'lg', 'md', 'sm', 'xs']
Vue.prototype.$valueByBreakpoint = function (values, propFunction) {
  const breakpointName = this.$vuetify.breakpoint.name
  return finBreakpoint.valueByBreakpoint(breakpointName,values, propFunction)
}
